(function () {
  'use strict';

  function initSlider(wrapper) {
    const track = wrapper.querySelector('.sh-track');
    if (!track) return;

    const slides = Array.from(track.querySelectorAll('.sh-slide'));
    if (slides.length === 0) return;

    const GAP = 24;
    const SPEED = 0.5;
    const SLIDE_W = 400;
    const ITEM_W = SLIDE_W + GAP;

    // Klona tills bandet är minst 3× skärmbredden
    const minWidth = window.innerWidth * 3;
    let cloneRounds = 0;

    while (track.scrollWidth < minWidth && cloneRounds < 20) {
      slides.forEach((slide) => {
        track.appendChild(slide.cloneNode(true));
      });
      cloneRounds++;
    }

    // Bredden av den ursprungliga uppsättningen (används för loop-reset)
    const cycleW = ITEM_W * slides.length;

    let offset = 0;
    let paused = false;

    function tick() {
      if (!paused) {
        offset += SPEED;

        if (offset >= cycleW) {
          offset -= cycleW;
        }

        track.style.transform = `translateX(${-offset}px)`;
      }

      requestAnimationFrame(tick);
    }

    document.addEventListener('visibilitychange', () => {
      paused = document.hidden;
    });

    requestAnimationFrame(tick);
  }

  function init() {
    document.querySelectorAll('.stadighet-hero-slider').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
